let r11332 = WXGAME.Report11332;
let openid = '';
import batchReport from '@tencent/wxgamelib/report/10861_batch.js';

export default {
  // sceneid, araa, pos, actid, optype
  report: function (appid, pos, actid, optype = 1, gifttype = 1, exter = '{}') {
    let l = {
      iSceneId: 20,
      iUIArea: 2001,
      sGameId: appid || '',
      iPositionId: pos,
      iActionId: actid,
      iOpType: optype,
      iGiftBagType: gifttype,
      sExternInfo: `${exter}`
    };
    r11332.report(l);
  },
  batchReport: function (appid, pid, pos, opstat, actid = 1, giftid = 0, exter = '{}') {
    let ext = typeof exter == 'string' ? JSON.parse(exter) : exter;
    let rpt = {
      sAppID: appid,
      iPid: pid,
      iPos: pos,
      nUrOpState: opstat,
      iActID: actid,
      iGiftID: giftid,
      iOptype: opstat == 1 ? 1 : 2,
      ExternInfo: exter
    };
    if (ext.openid) {
      rpt.openid = ext.openid;
      delete ext.openid;
      rpt.ExternInfo = JSON.stringify(ext);
    }
    console.log(30, rpt);
    batchReport(rpt);
  }
};
